/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'resource/radar': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0zm1 2.575A7.504 7.504 0 0117.426 9h-1.011A6.505 6.505 0 0011 3.585v-1.01zm0 3.046A4.501 4.501 0 0114.379 9h-1.042A3.494 3.494 0 0011 6.663V5.621zM14.379 11A4.501 4.501 0 0111 14.379v-1.042A3.494 3.494 0 0013.337 11h1.042zM9 2.575v1.01A6.505 6.505 0 003.585 9H2.574A7.505 7.505 0 019 2.575zm0 3.046v1.042A3.494 3.494 0 006.663 9H5.621A4.501 4.501 0 019 5.621zm0 11.804A7.504 7.504 0 012.574 11h1.011A6.505 6.505 0 009 16.415v1.01zm0-3.046A4.501 4.501 0 015.621 11h1.042A3.494 3.494 0 009 13.337v1.042zM8.5 10a1.5 1.5 0 113.001.001A1.5 1.5 0 018.5 10zm2.5 7.425v-1.01A6.505 6.505 0 0016.415 11h1.011A7.503 7.503 0 0111 17.425z"/>'
  }
})
